import type { SummonKind } from "../../../data/portal-ffa-catalog";
import type { TeamState, WorldState } from "./types";
import { setTeamGoal } from "./goals";
import {
  C,
  canAttack,
  dist,
  ranking,
  teamPreserved,
} from "./shared";
import { trySummon } from "./summon";

export function botTick(world: WorldState, team: TeamState): void {
  if (!team.alive || !team.personality) return;
  const p = C.bots[team.personality];
  if (!p) return;
  const master = world.entities.find((e) => e.id === team.masterId);
  if (!master) return;

  if (team.ledger.walletMana >= p.summonThreshold && team.summonCd <= 0) {
    const order: SummonKind[] = ["soldier", "raider", "guardian", "chaser"];
    for (const k of order) {
      if (trySummon(world, team.id, k)) break;
    }
  }
  if (team.sigils >= 1 && Math.random() < 0.02)
    trySummon(world, team.id, "hero");
  if (team.sigils >= 2 && Math.random() < 0.01)
    trySummon(world, team.id, "weapon");

  let bestX = team.goalX;
  let bestY = team.goalY;
  let bestScore = -1e9;

  for (const orb of world.orbs) {
    if (world.time < orb.collectableAt) continue;
    const d = dist(master.x, master.y, orb.x, orb.y);
    const jackpot = orb.value >= 20 ? p.opportunistLoot : p.manaSeek;
    const score = (orb.value * jackpot * 10) / (d + 40);
    if (score > bestScore) {
      bestScore = score;
      bestX = orb.x;
      bestY = orb.y;
    }
  }

  const ranks = ranking(world);
  const leader = ranks[0];
  for (const other of world.teams) {
    if (!other.alive || other.id === team.id) continue;
    if (!canAttack(world, team.id, other.id)) continue;
    const om = world.entities.find((e) => e.id === other.masterId);
    if (!om) continue;
    const d = dist(master.x, master.y, om.x, om.y);
    const myPV = teamPreserved(team);
    const theirPV = teamPreserved(other);
    let score = 0;
    if (theirPV < myPV * 0.85) score += (p.attackWeak * 50) / (d + 50);
    if (theirPV > myPV * 1.2) score -= (p.fearStrong * 40) / (d + 50);
    if (leader && other.id === leader.id)
      score += (p.leaderHunt * 30) / (d + 80);
    if (score > bestScore) {
      bestScore = score;
      bestX = om.x;
      bestY = om.y;
    }
  }

  for (const other of world.teams) {
    if (!other.alive || other.id === team.id) continue;
    const om = world.entities.find((e) => e.id === other.masterId);
    if (!om) continue;
    const d = dist(master.x, master.y, om.x, om.y);
    if (d < 200 && teamPreserved(other) > teamPreserved(team) * 1.3) {
      bestX = master.x + (master.x - om.x);
      bestY = master.y + (master.y - om.y);
      break;
    }
  }

  setTeamGoal(world, team.id, bestX, bestY);
}
